const banks = [
  {
    address: '0x08294930B8477F5017fafCd10AF85d4817126DBc',
    tokens: ['USDT', 'USDC', 'DAI', 'TUSD'],
    name: 'WMS Exchange',
    symbol: 'WMS',
    decimals: 18,
    rate: 1.1,
    bankSellingValue: 200,
    marketPlaceRoyaltyValue: 200,
    marketPlaceAddress: '0x00d2AaD407DbAdFCABE91fb1f77919ABf05Cb4Bd',
    logoURI:
      'https://assets.coingecko.com/coins/images/9576/thumb/BUSD.png?1568947766',
    card:['MIR', 'Yoo Pay'],
    cash: ['branch', 'delivery'],
  },
  {
    address: '0xa5262b58Ba5890225bf7EAB0c2b71C95D60B8D9e',
    tokens: ['USDT', 'USDC', 'DAI', 'TUSD'],
    name: 'Binance Exchange',
    symbol: 'BEx',
    decimals: 6,
    rate: 1.1,
    bankSellingValue: 200,
    marketPlaceRoyaltyValue: 200,
    marketPlaceAddress: '0x00d2AaD407DbAdFCABE91fb1f77919ABf05Cb4Bd',
    logoURI:
      'https://assets.coingecko.com/coins/images/6319/thumb/USD_Coin_icon.png?1547042389',
  },
  {
    address: '0x6a4caB16e7DDA2d964732Faf8DED5E67d8a91844',
    tokens: ['USDT', 'USDC', 'DAI', 'TUSD'],
    name: 'Crypto Exchange',
    symbol: 'CEX',
    decimals: 6,
    rate: 1.1,
    bankSellingValue: 200,
    marketPlaceRoyaltyValue: 200,
    marketPlaceAddress: '0x00d2AaD407DbAdFCABE91fb1f77919ABf05Cb4Bd',
    logoURI:
      'https://assets.coingecko.com/coins/images/325/thumb/Tether-logo.png?1598003707',
  },
  {
    address: '0x1543A8C608C240d97EdaeA1383ebAE25435E0014',
    tokens: ['USDT', 'USDC', 'DAI', 'TUSD'],
    name: 'SberBank',
    symbol: 'SBank',
    decimals: 18,
    rate: 1.1,
    bankSellingValue: 200,
    marketPlaceRoyaltyValue: 200,
    marketPlaceAddress: '0x00d2AaD407DbAdFCABE91fb1f77919ABf05Cb4Bd',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/4943.png',
  },
  {
    address: '0x04eDbadf8FeE0b8Db4124Bb747342409952F94F3',
    tokens: ['USDT', 'USDC', 'DAI', 'TUSD', 'BUSD'],
    name: 'Bank Saint Petersburg',
    symbol: 'SPBB',
    decimals: 18,
    rate: 1.1,
    bankSellingValue: 200,
    marketPlaceRoyaltyValue: 200,
    marketPlaceAddress: '0x00d2AaD407DbAdFCABE91fb1f77919ABf05Cb4Bd',
    logoURI:
      'https://assets.coingecko.com/coins/images/3449/thumb/tusd.png?1618395665',
  },
  {
    address: '0x5168B11C28C917198F4E25C228af7A8c45bED738',
    tokens: ['USDT', 'USDC'],
    name: 'Euro Bank',
    symbol: 'EUROB',
    decimals: 6,
    rate: 1.1,
    bankSellingValue: 200,
    marketPlaceRoyaltyValue: 200,
    marketPlaceAddress: '0x00d2AaD407DbAdFCABE91fb1f77919ABf05Cb4Bd',
    logoURI: 'https://s2.coinmarketcap.com/static/img/coins/64x64/20641.png',
  },
  {
    address: "0x3E3e45a0098633f5103d30E4E728d01e36edf104",
    tokens: ["USDT", "DAI", "TUSD"],
    name: "Bottega Exchange",
    symbol: "BoEx",
    // decimals: 6,
    rate: 1.1,
    bankSellingValue: 200,
    marketPlaceRoyaltyValue: 200,
    marketPlaceAddress: "0x00d2AaD407DbAdFCABE91fb1f77919ABf05Cb4Bd",
    logoURI:
        "https://static.coingecko.com/s/coingecko-logo-8903d34ce19ca4be1c81f0db30e924154750d208683fad7ae6f2ce06c76d0a56.png",
},
];
export default banks;
